export const stripHTMLTag = string => {
  if (!string) {
    return "";
  }
  return string.replace(/(<([^>]+)>)/gi, "");
};
